import React, { CSSProperties } from 'react';
import { Image, useDeviceType } from '@cian/ui-kit';

import { CardListItem } from './CardListItem';
import * as s from './CardListItem.css';

export interface IAdfoxCardListItem {
  height?: CSSProperties['height'];
  title: string;
  description: string;
  image: string;
  siteName?: string;
  footnote: string;
  url: string;
}

/**
 * Компонент рекламного блока в виде карточки в списке
 */
export const AdfoxCardListItem = ({
  image,
  title,
  description,
  siteName,
  footnote,
  url,
  height,
}: IAdfoxCardListItem) => {
  const deviceType = useDeviceType();
  const isPhone = () => deviceType === 'phone';

  const handleClick = () => {
    window.open(url, '_blank');
  };

  return (
    <CardListItem onClick={handleClick} height={height}>
      <div className={`${s['image-wrapper']} ${s['_adfox']}`}>
        <div className={`${s['adv-label']}`}>Реклама</div>

        <Image
          alt={title}
          borderRadius={0}
          objectFit="cover"
          preloader
          src={image}
          theme="light"
          title={title}
          height={isPhone() ? 109 : 180}
        />
      </div>

      <div className={`${s['content-wrapper']} ${s['_has-image']}`}>
        <div className={`${s['content-wrapper-inner']} ${s['_adfox']}`}>
          <div className={`${s['title']}`} title={title}>
            {title}
          </div>

          <div className={`${s['description']}`} title={description}>
            {description}
          </div>

          {siteName && <div className={`${s['site-name']}`}>{siteName}</div>}

          <div className={`${s['footnote']}`} title={footnote}>
            {footnote}
          </div>
        </div>
      </div>
    </CardListItem>
  );
};
